import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface DeleteBulkRoleActionsRequest {
  ids: number[];
}

export type DeleteBulkRoleActionsResponse = {
  isSuccess: boolean;
  message: string;
  data: any;
};

async function deleteBulkRoleActions(
  data: DeleteBulkRoleActionsRequest
): Promise<DeleteBulkRoleActionsResponse> {
  try {
    return (await axiosInstance.post("/RoleAction/DeleteBulk", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useDeleteBulkRoleActions() {
  return useMutation<DeleteBulkRoleActionsResponse, Error, DeleteBulkRoleActionsRequest>(
    (variables) => deleteBulkRoleActions(variables)
  );
}